module.exports = __webpack_public_path__ + "img/art_pic_02.ba9eb3ef.png";